import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import Header from './components/Header.vue'
import DialogLoginSign from '@/components/common/DialogLoginSign.vue'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!

  return (_openBlock(), _createBlock(_component_el_scrollbar, {
    height: "100%",
    style: {"background":"#FAF7F4"}
  }, {
    default: _withCtx(() => [
      _createVNode(Header),
      _createVNode(_component_router_view),
      _createVNode(DialogLoginSign)
    ]),
    _: 1
  }))
}
}

})